import { homeApi } from "@/api/template";
const state = {
  motherList: [],
  getMotherAgesList: [],
  currentAge: "",
  currentAgeData: [],
  sellingList: []
};
const getters = {
  motherList: state => state.motherList
};
const actions = {
  getMotherList({ commit, state }, id) {
    homeApi.appHomePage("958948609005359106").then(res => {
      return new Promise((resolve, reject) => {
        resolve();
        console.log(res);
        commit("motherList", res.data);
      });
    });
  }
};
const mutations = {
  motherList(state, data) {
    let newData = [];
    for (let i = 0; i < 11; i++) {
      newData.push(data[i]);
      newData[i].childrenData = [];
      for (let j = 11; j < data.length; j++) {
        if (data[i].moduleId == data[j].parentId) {
          newData[i].childrenData.push(data[j]);
        }
      }
    }
    state.motherList = newData;
    if (state.currentAge) {
      let crrentArr = state.currentAge.split("_");
      state.currentAgeData =
        newData[crrentArr[0]].childrenData[
          crrentArr[1]
        ].appTitleGoodsDto.titleItemDetail;
    }
    console.log(newData);
  },
  getMotherAges(state, data) {
    let arrId = data.split("_");
    state.getMotherAgesList = state.motherList[arrId[0]].childrenData[arrId[1]];
  },
  setCurrentAge(state, age) {
    state.currentAge = age;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
